import { ApolloError } from '@apollo/client';
import { useCallback, useState } from 'react';

import { isResultsTruncated } from '@utils/graphqlError';

type QueryResultWithErrors = {
  errors?: ReadonlyArray<{
    extensions?: Record<string, unknown> | null;
  }> | null;
  error?: ApolloError | null;
};

export function useResultsTruncated() {
  const [isTruncated, setIsTruncated] = useState(false);
  const setTruncatedFromError = useCallback(
    (result: ApolloError | QueryResultWithErrors | null | undefined) =>
      setIsTruncated(isResultsTruncated(result)),
    []
  );
  const resetTruncated = useCallback(() => setIsTruncated(false), []);
  return { isTruncated, setTruncatedFromError, resetTruncated };
}
